import React from 'react';
import { FormInstance } from 'antd';
import { ApprovalChainConfig } from '@approvals/components/approval-chain-template-select';

type EditStaffingRequestFormPartThreeProps = {
  disableApprovalChainSelection?: boolean;
  isApprovalNotesRequired?: boolean;
  organizationUnitId: string;
  visible: boolean;
  form: FormInstance;
};

export function EditStaffingRequestFormPartThree({
  disableApprovalChainSelection,
  isApprovalNotesRequired,
  organizationUnitId,
  visible,
  form,
}: EditStaffingRequestFormPartThreeProps) {
  const approvalChainActionType = 'staffing_request_update';

  if (!visible) {
    return <></>;
  }

  return (
    <ApprovalChainConfig
      form={form}
      actionType={approvalChainActionType}
      organizationUnitId={organizationUnitId}
      isApprovalNotesRequired={isApprovalNotesRequired}
      disableApprovalChainSelection={disableApprovalChainSelection}
    />
  );
}
